export const TimberbaseLogo = () => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-12 h-12 sm:w-16 sm:h-16"
  >
    <path
      d="M21.3315 50.6625C19.0437 50.6677 16.8149 49.937 14.9741 48.5784C13.1333 47.2199 11.7781 45.3054 11.1087 43.1178C10.4392 40.9301 10.491 38.5851 11.2562 36.4291C12.0215 34.273 13.4598 32.4202 15.3587 31.1441C14.1879 29.6813 13.4846 27.8999 13.3402 26.0318C13.1958 24.1638 13.6171 22.2955 14.5492 20.6701C15.4812 19.0447 16.881 17.7376 18.5662 16.9187C20.2514 16.0998 22.1441 15.8071 23.998 16.0787V15.9987C23.998 13.8772 24.8408 11.8425 26.3409 10.3423C27.8411 8.84217 29.8758 7.99939 31.9973 7.99939C34.1189 7.99939 36.1535 8.84217 37.6537 10.3423C39.1539 11.8425 39.9966 13.8772 39.9966 15.9987V16.1054C41.8505 15.8338 43.7432 16.1264 45.4284 16.9453C47.1137 17.7642 48.5134 19.0714 49.4455 20.6968C50.3775 22.3221 50.7988 24.1904 50.6544 26.0585C50.51 27.9266 49.8067 29.708 48.6359 31.1708C50.5229 32.4512 51.9499 34.3026 52.7075 36.4534C53.4651 38.6043 53.5133 40.9413 52.8452 43.1216C52.1771 45.302 50.8278 47.2107 48.9953 48.5679C47.1627 49.9251 44.9435 50.6592 42.6631 50.6625H21.3315Z"
      stroke="white"
      strokeWidth={5.33289}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.9974 50.6625V58.6618"
      stroke="white"
      strokeWidth={5.33289}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
